import { Box, useBreakpointValue } from '@chakra-ui/react'
import { ItList } from 'types/graphql'

import Carousel from 'src/components/widgets/Carousel/Carousel'
import ItListCard from 'src/components/widgets/ItListCard/ItListCard'
import { useAnalytics } from 'src/lib/hooks/analytics/useAnalytics'
import { goToItList } from 'src/lib/utils'

const ItListCarousel: React.FC<{
  itLists: ItList[]
  itemsPerRow: number
  showUsername?: boolean
}> = ({ itLists, itemsPerRow, showUsername = true }) => {
  const { trackItListClicked } = useAnalytics()
  const smMarginLeft = useBreakpointValue({ sm: 4, md: 6 })
  const trackAndGoToItList = (itList: ItList) => {
    trackItListClicked(itList, itList.relationship === 'owner')
    goToItList(itList)
  }
  return (
    <Box mx={{ sm: 4, lg: 0 }} w="100%">
      <Carousel
        smItemWidth={315}
        smMarginLeft={smMarginLeft}
        gapSmMd={4}
        lgItemsPerRow={itemsPerRow}
        lgOffsetArrows={-35}
      >
        {itLists.map((itList) => (
          <ItListCard
            key={itList.id}
            {...itList}
            relationship={itList.relationship}
            showUsername={showUsername}
            size="sm"
            onClick={() => trackAndGoToItList(itList)}
          />
        ))}
      </Carousel>
    </Box>
  )
}

export default ItListCarousel
